import { Favorite, FavoriteBorder } from "@mui/icons-material";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import {
	Box,
	Checkbox,
	FormControl,
	FormControlLabel,
	FormGroup,
	FormHelperText,
	FormLabel,
	Grid
} from "@mui/material";
import { pink } from "@mui/material/colors";
import React from "react";

const Checkboxes = ({gilad, handleChange, jason, antoine, error}) => {
	return (
		<Box>
			<Grid container spacing={3}>
				<Grid item>
					<Checkbox inputProps={{'aria-label': 'Checkbox demo'}} defaultChecked/>
				</Grid>
				<Grid item>
					<Checkbox inputProps={{'aria-label': 'Checkbox demo'}}/>
				</Grid>
				<Grid item>
					<Checkbox inputProps={{'aria-label': 'Checkbox demo'}} disabled/>
				</Grid>
				<Grid item>
					<Checkbox inputProps={{'aria-label': 'Checkbox demo'}} disabled checked/>
				</Grid>
				<Grid item>
					<FormGroup>
						<FormControlLabel control={<Checkbox defaultChecked/>} label="Label"/>
						<FormControlLabel required control={<Checkbox/>} label="Required"/>
						<FormControlLabel disabled control={<Checkbox/>} label="Disabled"/>
					</FormGroup>
				</Grid>
				<Grid item>
					<Checkbox inputProps={{'aria-label': 'Checkbox demo'}} defaultChecked size="small"/>
				</Grid>
				<Grid item>
					<Checkbox inputProps={{'aria-label': 'Checkbox demo'}} defaultChecked/>
				</Grid>
				<Grid item>
					<Checkbox
						inputProps={{'aria-label': 'Checkbox demo'}}
						defaultChecked
						sx={{'& .MuiSvgIcon-root': {fontSize: 28}}}
					/>
				</Grid>
				<Grid item>
					<Checkbox inputProps={{'aria-label': 'Checkbox demo'}} defaultChecked/>
				</Grid>
				<Grid item>
					<Checkbox inputProps={{'aria-label': 'Checkbox demo'}} defaultChecked color="secondary"/>
				</Grid>
				<Grid item>
					<Checkbox inputProps={{'aria-label': 'Checkbox demo'}} defaultChecked color="success"/>
				</Grid>
				<Grid item>
					<Checkbox inputProps={{'aria-label': 'Checkbox demo'}} defaultChecked color="default"/>
				</Grid>
				<Grid item>
					<Checkbox
						inputProps={{'aria-label': 'Checkbox demo'}}
						defaultChecked
						sx={{
							color: pink[800],
							'&.Mui-checked': {
								color: pink[600],
							},
						}}
					/>
				</Grid>
				<Grid item>
					<Checkbox inputProps={{'aria-label': 'Checkbox demo'}} icon={<FavoriteBorder/>}
							  checkedIcon={<Favorite/>}/>
				</Grid>
				<Grid item>
					<Checkbox
						inputProps={{'aria-label': 'Checkbox demo'}}
						icon={<BookmarkBorderIcon/>}
						checkedIcon={<BookmarkIcon/>}
					/>
				</Grid>
				<Box sx={{display: 'flex'}}>
					<FormControl sx={{m: 3}} component="fieldset" variant="standard">
						<FormLabel component="legend">Assign responsibility</FormLabel>
						<FormGroup>
							<FormControlLabel
								control={
									<Checkbox checked={gilad} onChange={handleChange} name="gilad"/>
								}
								label="Gilad Gray"
							/>
							<FormControlLabel
								control={
									<Checkbox checked={jason} onChange={handleChange} name="jason"/>
								}
								label="Jason Killian"
							/>
							<FormControlLabel
								control={
									<Checkbox checked={antoine} onChange={handleChange} name="antoine"/>
								}
								label="Antoine Llorca"
							/>
						</FormGroup>
						<FormHelperText>Be careful</FormHelperText>
					</FormControl>
					<FormControl
						required
						error={error}
						component="fieldset"
						sx={{m: 3}}
						variant="standard"
					>
						<FormLabel component="legend">Pick two</FormLabel>
						<FormGroup>
							<FormControlLabel
								control={
									<Checkbox checked={gilad} onChange={handleChange} name="gilad"/>
								}
								label="Gilad Gray"
							/>
							<FormControlLabel
								control={
									<Checkbox checked={jason} onChange={handleChange} name="jason"/>
								}
								label="Jason Killian"
							/>
							<FormControlLabel
								control={
									<Checkbox checked={antoine} onChange={handleChange} name="antoine"/>
								}
								label="Antoine Llorca"
							/>
						</FormGroup>
						<FormHelperText>You can display an error</FormHelperText>
					</FormControl>
				</Box>
				<Box>
					<FormControl component="fieldset">
						<FormLabel component="legend">Label placement</FormLabel>
						<FormGroup aria-label="position" row>
							<FormControlLabel
								value="top"
								control={<Checkbox/>}
								label="Top"
								labelPlacement="top"
							/>
							<FormControlLabel
								value="start"
								control={<Checkbox/>}
								label="Start"
								labelPlacement="start"
							/>
							<FormControlLabel
								value="bottom"
								control={<Checkbox/>}
								label="Bottom"
								labelPlacement="bottom"
							/>
							<FormControlLabel
								value="end"
								control={<Checkbox/>}
								label="End"
								labelPlacement="end"
							/>
						</FormGroup>
					</FormControl>
				</Box>
			</Grid>
		</Box>
	)
}

export default Checkboxes;